// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 80,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};

/** Sidebar sempre escura (independente do tema light/dark do conteudo). */
export const NAV_CHROME = {
  bgcolor: '#0A0606',
  borderColor: 'rgba(255, 255, 255, 0.12)',
} as const;
